import React, { Component } from 'react';
import { Icon, Dropdown } from 'semantic-ui-react';
import PropTypes from 'prop-types';

export default class BookingSelectListMultiple extends Component {
  static propTypes = {
    disabled: PropTypes.bool,
    filterName: PropTypes.string.isRequired,
    headerText: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    })).isRequired,
    placeholder: PropTypes.string,
    // Usually an array; an over-long URL list arrives as { 0: .., 1: .. } and a single URL value
    // as a plain string. toValueArray accepts all three (CPI-1444).
    value: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.string.isRequired),
      PropTypes.objectOf(PropTypes.string),
      PropTypes.string,
    ]),
    search: PropTypes.string,
    renderLabel: PropTypes.func,
    selectedText: PropTypes.string,
  }
  static defaultProps = {
    hasSearch: false,
    options: [],
    placeholder: 'Select an Option',
    value: [],
  }
  // The selected values arrive from the page URL. An over-long list used to come back as an object
  // ({ 0: 'a', 1: 'b', ... }) and a single plain value as a string; either one made `.some`/`.push`
  // throw during render and blanked the whole page (CPI-1444). Always work on an array.
  static toValueArray = (value) => {
    if (Array.isArray(value)) {
      return value;
    }
    if (value && typeof value === 'object') {
      return Object.keys(value)
        .sort((a, b) => Number(a) - Number(b))
        .map(key => value[key])
        .filter(v => typeof v === 'string');
    }
    if (typeof value === 'string' && value !== '') {
      return [value];
    }
    return [];
  }
  static getPropsToState = (props) => {
    const value = BookingSelectListMultiple.toValueArray(props.value);
    let options = props.options || [];
    const search = props.search || '';
    const limit = props.limit || 0;
    if (limit > 0) {
      options = options.map(d => ({
        disabled: limit > 0 && value.length >= limit,
        ...d,
      }));
    }
    return {
      value,
      options,
      search,
    };
  }
  constructor(props) {
    super(props);
    const state = BookingSelectListMultiple.getPropsToState(props);
    this.state = state;
  }
  componentWillReceiveProps(nextProps) {
    const state = BookingSelectListMultiple.getPropsToState(nextProps);
    this.setState({ ...state });
  }
  handleOnChange = (e, { value }) => {
    const current = [].concat(this.state.value);
    const index = current.findIndex(v => v === value);
    if (index >= 0) {
      current.splice(index, 1);
    } else {
      current.push(value);
    }
    const newValue = current;
    this.setState({ value: newValue }, () => {
      this.props.onChange(newValue, this.props.filterName);
    });
  }
  render() {
    const classNames = ['booking'];
    if (this.state.value.length > 0) {
      classNames.push('selected');
    }
    return (
      <Dropdown
        className={classNames.join(' ')}
        closeOnChange={false}
        fluid
        header={this.props.headerText}
        onChange={this.handleOnChange}
        options={this.state.options.map(op => ({
          ...op,
          icon: <Icon name={`square ${this.state.value.some(v => v === op.value) ? 'check' : 'outline'}`} />,
        }))}
        renderLabel={this.props.renderLabel}
        selectOnBlur={false}
        text={
          this.state.value.length > 0
          ? `${this.state.value.length} ${this.props.selectedText || 'selected'}` || null
          : this.props.placeholder
        }
        placeholder={this.state.value.length > 0 ? null : this.props.placeholder}
        disabled={this.props.disabled}
        value=""
        scrolling
        search
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Filters/BookingSelectListMultiple.jsx